import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import { ValidatorForm } from "react-material-ui-form-validator";
import { Autocomplete } from "@mui/material";
import { Select, MenuItem } from "@mui/material";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import AddIcon from "@material-ui/icons/Add";
// import AddLinkIcon from "@mui/icons-material/AddLink";
import InfoTooltip from "../../givBee/infoTooltip/InfoTooltip";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import SaveButton from "../../givBee/buttons/SaveButton";
import Button from "@material-ui/core/Button";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Utils from "../../../provider/Utils";
import AdminFetchServerData from "../../../provider/AdminFetchServerData";
import store from "../../../redux/store";
import AdminMenuWithBreadScrum from "../adminMenu/AdminMenuWithBreadScrum";
import PtsAlert from "../../givBee/ptsAlert/PtsAlert";
import CreateButton from "../../givBee/buttons/CreateButton";
import CancelIconButton from "../../givBee/buttons/CancelIconButton";
import {
  ApGetMessageTemplate_Url,
  ApCreateMessageTemplate_Url,
  ApUpdateMessageTemplate_Url,
  ApDeleteMessageTemplate_Url,
} from "../../../provider/ServiceUrl";
import { MESSAGE_TYPES } from "../../../provider/Enums";
import MessageTemplateQuestion from "./MessageTemplateQuestion";

class MessageTemplate extends Component {
  header = store.getState().adminHeader.adminHeader;
  title = "Message Template";
  breadCrumb = [
    { pageid: "/smsTemplateList", uiname: "Message Template List" },
    { pageid: "", uiname: "Message Template" },
  ];
  itemReferenceList = [];
  valueIndexMap = new Map();
  constructor(props) {
    super(props);
    let action = props.action;
    let smsTemplateId = props.smsTemplateId;
    let businessDomain = null;
    if (!action && props.state) {
      action = props.state.action;
      smsTemplateId = props.state.smsTemplateId;
      businessDomain = props.state.businessDomain;
    }
    if (null !== smsTemplateId && smsTemplateId > 0) {
      this.getMsgTemplateDetails(smsTemplateId);
    }
    this.state = {
      action: action,
      smsTemplateId: smsTemplateId,
      businessDomain: businessDomain,
      messageTypeList: [],
      businessTypeList: [],
      smsVariablesList: [],
      smsCategoryColorList: [],
      questionItems: [],
      interactiveQuestionTypeList: [],
      smsFundraisingOptionList: [],
      messageName: "",
      keyword: "",
      textMessage: "",
      introMessage: "",
      closingTextMessage: "",
      currentIndex: 0,
      amountQuestion: "",
      amountOption1: "50",
      amountOption2: "25",
      amountOption3: "10",
      amountOption4: null,
      donationAmount: "",
      donnerExperince: "",
      donationAmountList: ["50", "25", "10"],
      messageType: null,
      businessType: null,
      isIntroMessage: false,
      donationAmountError: false,
      getUpdatePermission: false,
      getDeletePermission: false,
      render: false,
    };
  }
  componentDidMount() {
    const postObject = {
      header: this.header,
      businessDomainName: this.state.businessDomain?.name,
    };

    AdminFetchServerData.callPostService(
      "/apStaticms/getMessageTemplateData",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let messageTypeList = output.data.messageTypeList;
        let businessTypeList = output.data.businessTypeList;
        let smsCategoryColorList = output.data.smsCategoryColorList;
        let interactiveQuestionTypeList =
          output.data.interactiveQuestionTypeList;
        let smsVariablesList = output.data.smsVariablesList;
        let smsFundraisingOptionList = output.data.smsFundraisingOptionList;
        const modifiedData = [...smsFundraisingOptionList];
        modifiedData.map((item) => {
          if (Utils.equalsIgnoreCase(item.name, "Without Introduction")) {
            item.isChecked = true;
            return item;
          }
        });
        this.setState({
          render: true,
          messageTypeList: messageTypeList,
          messageType: Utils.getArrayElement(messageTypeList, 0),
          businessTypeList: businessTypeList,
          interactiveQuestionTypeList: interactiveQuestionTypeList,
          smsVariablesList: smsVariablesList,
          smsFundraisingOptionList: modifiedData,
          donnerExperince: Utils.getArrayElement(smsFundraisingOptionList, 0),
          smsCategoryColorList: smsCategoryColorList,
          colorCode: Utils.getArrayElement(smsCategoryColorList, 0)?.hashColor,
          colorCodeId: Utils.getArrayElement(smsCategoryColorList, 0)?.id,
        });
      }
    });
  }
  getMsgTemplateDetails(smsTemplateId) {
    const postObject = {
      header: this.header,
      messageTemplate: {
        id: smsTemplateId,
      },
    };
    AdminFetchServerData.callPostService(ApGetMessageTemplate_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          let msgTemplateDetails = output.data.messageTemplate;
          let messageTemplateFundRaisingDetails =
            msgTemplateDetails?.messageTemplateFundRaising;
          let getPermission = Utils.getRolePermission(
            output.data?.privilegeList
          );
          let getUpdatePermission = getPermission[3];
          let getDeletePermission = getPermission[4];
          let questionType = {};
          for (
            let i = 0;
            i < msgTemplateDetails.messageTemplateQuestions.length;
            i++
          ) {
            let ref = React.createRef();
            this.itemReferenceList.push(ref);
            msgTemplateDetails.messageTemplateQuestions[i].operation = "Update";
            if (
              msgTemplateDetails.messageTemplateQuestions[i]?.questionType
                ?.type === "Pledge"
            ) {
              questionType.type =
                msgTemplateDetails.messageTemplateQuestions[
                  i
                ]?.questionType?.type;
              this.valueIndexMap.set(i, questionType.type);
            }
          }

          // if (
          //   Utils.equalsIgnoreCase(
          //     msgTemplateDetails.messageType?.type,
          //     MESSAGE_TYPES.fundraising
          //   ) &&
          //   Utils.equalsIgnoreCase(this.crmIntegration, "BlackBaudCRM")
          // ) {
          //   this.getCrmStaticData(
          //     true,
          //     msgTemplateDetails.blackbaudSmsPropertiesVo?.appeal
          //   );
          // }

          let donationAmountList = [];
          if (
            messageTemplateFundRaisingDetails?.amountOption1 !== null &&
            messageTemplateFundRaisingDetails?.amountOption1 !== undefined
          ) {
            donationAmountList.push(
              messageTemplateFundRaisingDetails?.amountOption1
            );
          }
          if (
            messageTemplateFundRaisingDetails?.amountOption2 !== null &&
            messageTemplateFundRaisingDetails?.amountOption2 !== undefined
          ) {
            donationAmountList.push(
              messageTemplateFundRaisingDetails?.amountOption2
            );
          }
          if (
            messageTemplateFundRaisingDetails?.amountOption3 !== null &&
            messageTemplateFundRaisingDetails?.amountOption2 !== undefined
          ) {
            donationAmountList.push(
              messageTemplateFundRaisingDetails?.amountOption3
            );
          }
          if (
            messageTemplateFundRaisingDetails?.amountOption4 !== null &&
            messageTemplateFundRaisingDetails?.amountOption2 !== undefined
          ) {
            donationAmountList.push(
              messageTemplateFundRaisingDetails?.amountOption4
            );
          }
          const modifiedData = [...this.state.smsFundraisingOptionList];
          modifiedData?.map((item) => {
            item.isChecked =
              item.id ===
              +messageTemplateFundRaisingDetails?.donnerExperince?.id;
            return item;
          });
          let isIntroMessage = false;
          if (
            Utils.equalsIgnoreCase(
              messageTemplateFundRaisingDetails?.donnerExperince?.name,
              "With Introduction"
            )
          ) {
            isIntroMessage = true;
          }

          this.setState({
            render: true,
            id: msgTemplateDetails.id,
            messageName: msgTemplateDetails.messageName,
            keyword: msgTemplateDetails.keyword,
            textMessage: msgTemplateDetails.textMessage,
            businessType: msgTemplateDetails.businessType,
            messageType: msgTemplateDetails.messageType,
            closingTextMessage: msgTemplateDetails.closingMessage,
            questionItems: msgTemplateDetails.messageTemplateQuestions,
            introMessage: messageTemplateFundRaisingDetails?.introMessage,
            fundraisingGoal: msgTemplateDetails?.goalAmount,
            amountQuestion: messageTemplateFundRaisingDetails?.amountQuestion,
            amountOption1: messageTemplateFundRaisingDetails?.amountOption1,
            amountOption2: messageTemplateFundRaisingDetails?.amountOption2,
            amountOption3: messageTemplateFundRaisingDetails?.amountOption3,
            amountOption4: messageTemplateFundRaisingDetails?.amountOption4,
            donationAmountList: donationAmountList,
            donnerExperince: messageTemplateFundRaisingDetails?.donnerExperince,
            smsMessageFundRaisingId: messageTemplateFundRaisingDetails?.id,
            smsFundraisingOptionList: modifiedData,
            isIntroMessage: isIntroMessage,
            getUpdatePermission: getUpdatePermission,
            getDeletePermission: getDeletePermission,
          });
        }
      })
      .catch((error) => { });
  }

  handleMessageNameChange(e) {
    this.setState({ messageName: e.target.value });
  }
  handleKeywordChange(e) {
    this.setState({ keyword: e.target.value });
  }

  adjustTextareaHeight = () => {
    if (this.textareaRef.current) {
      this.textareaRef.current.style.height = "auto"; // Reset height
      this.textareaRef.current.style.height =
        this.textareaRef.current.scrollHeight + "px"; // Set new height
    }
  };

  handleTextMessageChange(e) {
    let cursorPosition = e.target.selectionStart;
    let val = e.target.value;

    if (this.accountSettings?.textMessageLength < Utils.countLetters(val)) {
      this.setState({
        cursorPosition: cursorPosition,
        textMessage: val,
      });
    } else {
      this.setState({
        cursorPosition: cursorPosition,
        textMessage: val,
      });
    }
    this.adjustTextareaHeight();
  }

  handleTextMessageInsert(selectedValue) {
    const shouldInsertSpace =
      this.state.cursorPosition > 0 &&
      this.state.textMessage[this.state.cursorPosition - 1] !== " ";

    const newText =
      this.state.textMessage.substring(0, this.state.cursorPosition) +
      (shouldInsertSpace ? " " : "") +
      selectedValue.value +
      this.state.textMessage.substring(this.state.cursorPosition);

    this.setState(
      {
        textMessage: newText,
        cursorPosition:
          this.state.cursorPosition +
          selectedValue.value.length +
          (shouldInsertSpace ? 1 : 0),
      },
      () => {
        const input = document.getElementById("messageBox");
        if (input) {
          input.focus();
          input.setSelectionRange(
            this.state.cursorPosition,
            this.state.cursorPosition
          );
        }
      }
    );
  }

  handleColorCodeChange(e) {
    const selectedId = e.target.value;
    const selectedOption = this.smsCategoryColorList.find(
      (item) => item.id === selectedId
    );

    if (selectedOption) {
      this.setState({
        colorCode: selectedOption.hashColor,
        colorCodeId: selectedOption.id,
      });
    }
  }

  handleBusinessTypeChange(selectedValue) {
    this.setState({ businessType: selectedValue });
  }
  handleMessageTypeChange(selectedValue) {
    if (
      Utils.equalsIgnoreCase(selectedValue?.type, MESSAGE_TYPES.interactive)
    ) {
      if (this.state.questionItems.length < 1) {
        this.addQuestionItem();
      }
      this.setState({
        messageType: selectedValue,
        textMessage: this.state.textMessage,
        messageName: this.state.messageName,
        keyword: this.state.keyword,
      });
    } else if (
      Utils.equalsIgnoreCase(
        selectedValue?.type,
        MESSAGE_TYPES.interactivePledge
      )
    ) {
      if (this.state.questionItems.length < 1) {
        this.addQuestionItem();
      }
      this.setState({
        messageType: selectedValue,
        textMessage: this.state.textMessage,
        messageName: this.state.messageName,
        keyword: this.state.keyword,
      });
    } else {
      this.setState({ messageType: selectedValue });
    }
  }

  createMsgTemplateToBackend() {
    for (let i = 0; i < this.itemReferenceList.length; i++) {
      if (this.itemReferenceList[i].current) {
        this.state.questionItems[i].questionType =
          this.itemReferenceList[i].current.state.questionType;
        this.state.questionItems[i].discontinueReason =
          this.itemReferenceList[i].current.state.discontinueReason;
        this.state.questionItems[i].question =
          this.itemReferenceList[i].current.state.question;
        this.state.questionItems[i].step = i + 1;
      }
    }

    if (
      Utils.equalsIgnoreCase(
        this.state.messageType?.type,
        MESSAGE_TYPES.fundraising
      )
    ) {
      if (this.state.donationAmountList.length === 0) {
        this.setState({
          donationAmountError: true,
        });
        return;
      }

      let smsMessageFundRaising = {
        amountQuestion: this.state.amountQuestion,
        introMessage: this.state.introMessage,
        amountOption1: this.state.amountOption1,
        amountOption2: this.state.amountOption2,
        amountOption3: this.state.amountOption3,
        amountOption4: this.state.amountOption4,
        donnerExperince: this.state.donnerExperince,
      };
      this.setState({
        smsMessageFundRaising: smsMessageFundRaising,
        messageTemplate: null,
        textMessage: "",
      });
    }

    const postObject = {
      header: this.header,
      messageTemplate: {
        messageName: this.state.messageName,
        keyword: this.state.keyword,
        textMessage: this.state.textMessage,
        businessType: { id: this.state.businessType?.id },
        messageType: { id: this.state.messageType?.id },
        closingMessage: this.state.closingTextMessage,
        messageTemplateQuestions: this.state.questionItems,
        goalAmount: this.state.fundraisingGoal,
        messageTemplateFundRaising: this.state.smsMessageFundRaising,
        categoryColor: {
          id: this.state.colorCodeId,
        },
      },
    };
    AdminFetchServerData.callPostService(
      ApCreateMessageTemplate_Url,
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        let messageTemplateData = output.data.messageTemplate;
        this.getMsgTemplateDetails(messageTemplateData.id);
        this.setState({
          action: "view",
        });
      }
    });
  }

  createCancel() {
    this.props.navigate("/smsTemplateList", {
      state: {
        businessDomain: this.state.businessDomain,
      },
    });
  }

  editCancel() {
    this.setState({ action: "view", smsTemplateId: this.state.id });
  }
  viewCancel() {
    this.props.navigate("/smsTemplateList", {
      state: {
        businessDomain: this.state.businessDomain,
      },
    });
  }

  editMsgTemplateDetails() {
    this.setState({ action: "edit", smsTemplateId: this.state.id });
  }

  updateMsgTemplateToBackend() {
    for (let i = 0; i < this.itemReferenceList.length; i++) {
      if (this.itemReferenceList[i].current) {
        this.state.questionItems[i].questionType =
          this.itemReferenceList[i].current.state.questionType;
        this.state.questionItems[i].discontinueReason =
          this.itemReferenceList[i].current.state.discontinueReason;
        this.state.questionItems[i].question =
          this.itemReferenceList[i].current.state.question;
        this.state.questionItems[i].step = i + 1;
      }
    }

    if (
      Utils.equalsIgnoreCase(
        this.state.messageType?.type,
        MESSAGE_TYPES.fundraising
      )
    ) {
      if (this.state.donationAmountList.length === 0) {
        this.setState({
          donationAmountError: true,
        });
        return;
      }

      let smsMessageFundRaising = {
        id: this.state.smsMessageFundRaisingId,
        amountQuestion: this.state.amountQuestion,
        introMessage: this.state.introMessage,
        amountOption1: this.state.amountOption1,
        amountOption2: this.state.amountOption2,
        amountOption3: this.state.amountOption3,
        amountOption4: this.state.amountOption4,
        donnerExperince: { id: this.state.donnerExperince?.id },
      };
      this.setState({
        smsMessageFundRaising: smsMessageFundRaising,
        messageTemplate: null,
        textMessage: "",
      });
    }

    const postObject = {
      header: this.header,
      messageTemplate: {
        id: this.state.id,
        messageName: this.state.messageName,
        keyword: this.state.keyword,
        textMessage: this.state.textMessage,
        closingMessage: this.state.closingTextMessage,
        messageTemplateQuestions: this.state.questionItems,
        businessType: { id: this.state.businessType?.id },
        messageType: { id: this.state.messageType?.id },
        goalAmount: this.state.fundraisingGoal,
        messageTemplateFundRaising: this.state.smsMessageFundRaising,
        categoryColor: {
          id: this.state.colorCodeId,
        },
      },
    };
    AdminFetchServerData.callPostService(
      ApUpdateMessageTemplate_Url,
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        let messageTemplateData = output.data.messageTemplate;
        this.getMsgTemplateDetails(messageTemplateData.id);
        this.setState({
          action: "view",
        });
      }
    });
  }

  deleteMsgTemplateDetails() {
    const postObject = {
      header: this.header,
      messageTemplate: {
        id: this.state.id,
      },
    };

    AdminFetchServerData.callPostService(
      ApDeleteMessageTemplate_Url,
      postObject
    )
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.props.navigate("/smsTemplateList");
        }
      })
      .catch((error) => { });
  }

  addQuestionItem() {
    let items = this.state.questionItems;
    let item = {
      operation: "ADD",
      question: "",
      questionType: Utils.getArrayElement(
        this.state.interactiveQuestionTypeList,
        0
      ),
    };
    items.push(item);
    this.itemReferenceList.push(React.createRef());
    this.setState({ questionItems: items });
  }

  smsQuestionTypeChange(selectedValue, index) {
    this.valueIndexMap.set(index, selectedValue.type);
    this.setState({ questionType: selectedValue });
  }

  QuestionItemDeleted(item, index) {
    if (this.valueIndexMap.has(index)) {
      this.valueIndexMap.delete(index);
    }
    let items = [];
    let itemToTrash = -999;
    for (let i = 0; i < this.state.questionItems.length; i++) {
      let invItem = this.state.questionItems[i];
      if (Utils.equalsIgnoreCase(this.state.action, "create")) {
        if (item.isDelete === true && item.index === i) {
          itemToTrash = i;
          continue;
        } else {
          invItem =
            this.itemReferenceList[i] && this.itemReferenceList[i].current
              ? this.itemReferenceList[i].current.state
              : invItem;
          items.push(invItem);
        }
      } else {
        if (item.isDelete === true && item.index === i) {
          if (Utils.equalsIgnoreCase(item.operation, "Add")) {
            itemToTrash = i;
            continue;
          }
          invItem.operation = "Delete";
        } else {
          invItem =
            this.itemReferenceList[i] && this.itemReferenceList[i].current
              ? this.itemReferenceList[i].current.state
              : invItem;
        }
        items.push(invItem);
      }
    }

    for (let i = 0; i < this.state.questionItems.length; i++) {
      if (i === itemToTrash) {
      }
    }

    let randomKey = Math.random();
    this.setState({ refreshKey: randomKey, questionItems: items });
  }

  handleClosingTextMessageChange(e) {
    let val = e.target.value;
    let cursorPosition = e.target.selectionStart;
    let isMeterSetting = val.includes("{{Payment Link}}");
    // if (isMeterSetting) {
    //   this.getPledgeStaticData();
    // }
    if (this.accountSettings?.textMessageLength < Utils.countLetters(val)) {
      this.setState({
        closingTextMessage: val,
        isTextMessageLength: true,
        cursorPosition: cursorPosition,
        isMeterSetting: isMeterSetting,
        isPledge: isMeterSetting === false && false,
      });
    } else {
      this.setState({
        closingTextMessage: val,
        isTextMessageLength: false,
        cursorPosition: cursorPosition,
        isMeterSetting: isMeterSetting,
        isPledge: isMeterSetting === false && false,
      });
    }
  }

  handleClosingInsert(selectedValue) {
    const shouldInsertSpace =
      this.state.cursorPosition > 0 &&
      this.state.closingTextMessage[this.state.cursorPosition - 1] !== " ";

    const newText =
      this.state.closingTextMessage.substring(0, this.state.cursorPosition) +
      (shouldInsertSpace ? " " : "") +
      selectedValue.value +
      this.state.closingTextMessage.substring(this.state.cursorPosition);

    this.setState(
      {
        closingTextMessage: newText,
        cursorPosition:
          this.state.cursorPosition +
          selectedValue.value.length +
          (shouldInsertSpace ? 1 : 0),
      },
      () => {
        // Ensure cursor is placed correctly
        const input = document.getElementById("closingMessageBox");
        if (input) {
          input.focus();
          input.setSelectionRange(
            this.state.cursorPosition,
            this.state.cursorPosition
          );
        }
      }
    );
  }

  handleClosingTextMessageInsert(selectedValue) {
    this.setState({
      closingTextMessage: `${this.state.closingTextMessage.substring(
        0,
        this.state.start
      )} ${selectedValue.value} ${this.state.closingTextMessage.substring(
        this.state.start
      )}`,
    });
  }

  handleChange(e, selectedValue) {
    const value = e.target.value;
    const modifiedData = [...this.state.smsFundraisingOptionList];
    modifiedData.map((item) => {
      item.isChecked = item.id === +value;
      return item;
    });
    let isIntroMessage = false;
    let introMessage = "";
    if (selectedValue.name === "With Introduction") {
      isIntroMessage = true;
      introMessage = "STOP to optout";
    } else {
      isIntroMessage = false;
      introMessage = "";
    }

    this.setState({
      introMessage: introMessage,
      isIntroMessage: isIntroMessage,
      smsFundraisingOptionList: modifiedData,
      donnerExperince: selectedValue,
    });
  }

  handleDonationAmountChange(e) {
    let val = e.target.value;
    this.setState({
      donationAmount: val,
    });
  }

  handleFundraisingGoalChange(e) {
    this.setState({
      fundraisingGoal: e.target.value,
    });
  }
  addDonationAmount() {
    let items = this.state.donationAmountList;
    if (items.length <= 3) {
      items.push(this.state.donationAmount);
    }
    this.setState({
      donationAmountList: items,
      amountOption1: items[0],
      amountOption2: items[1],
      amountOption3: items[2],
      amountOption4: items[3],
      donationAmount: "",
      donationAmountError: false,
    });
  }

  deleteDonationAmount(id) {
    const currentIndex = this.state.donationAmountList.findIndex(
      (d, index) => index === id
    );
    let currentList = [...this.state.donationAmountList];
    currentList.splice(currentIndex, 1);
    this.setState({
      donationAmountList: currentList,
      amountOption1: currentList[0] === undefined ? null : currentList[0],
      amountOption2: currentList[1],
      amountOption3: currentList[2],
      amountOption4: currentList[3],
    });
  }

  handleAmountQustionChange(e) {
    this.setState({
      amountQuestion: e.target.value,
    });
  }

  handleIntroMessageChange(e) {
    this.setState({
      introMessage: e.target.value,
    });
  }
  handleNext = () => {
    const updatedMessages = [
      ...this.state.questionItems,
      {
        question: this.state.closingTextMessage,
        step: this.state.questionItems?.length + 1,
      },
    ];

    this.setState((prevState) => ({
      currentIndex: Math.min(
        prevState.currentIndex + 1,
        updatedMessages.length - 1
      ),
    }));
  };

  handlePrev = () => {
    this.setState((prevState) => ({
      currentIndex: Math.max(prevState.currentIndex - 1, 0),
    }));
  };

  render() {
    this.textareaRef = React.createRef();
    if (this.state.action === "create") {
      return this.createMessageTemplate();
    } else if (this.state.action === "edit") {
      return this.editMessageTemplate();
    } else if (this.state.action === "view") {
      return this.viewMessageTemplate();
    }
  }
  createMessageTemplate() {
    if (this.state.render === false) {
      return <div />;
    } else {
      let questionitems = [];
      let itemLoc = 1;
      this.state.questionItems.forEach((element, index) => {
        if ("Delete" !== element.operation) {
          element.step = itemLoc++;
          let itemkey = index + "-" + this.state.refreshKey;
          questionitems.push(
            <MessageTemplateQuestion
              ref={this.itemReferenceList[index]}
              key={itemkey}
              data={element}
              interactiveQuestionTypeList={
                this.state.interactiveQuestionTypeList
              }
              smsVariablesList={this.state.smsVariablesList}
              srno={index}
              action="edit"
              iteamIndex={index}
              questionItems={this.state.questionItems}
              onAdd={this.addQuestionItem.bind(this)}
              onDelete={this.QuestionItemDeleted.bind(this)}
              onSuccess={this.smsQuestionTypeChange.bind(this)}
            />
          );
        }
      });
      return (
        <>
          <AdminMenuWithBreadScrum
            breadCrumb={this.breadCrumb}
            history={this.props.history}
            name={this.title}
            businessDomain={this.state.businessDomain}
            pageId="viewPage"
          />
          <div className="row">
            <ValidatorForm
              className="text-start"
              ref="form"
              onSubmit={this.createMsgTemplateToBackend.bind(this)}
            >
              <div className="row">
                <div className="col-md-12">
                  <div className="card " id="giveBeeCard">
                    <div
                      className="card-body p-2"
                    // style={{ padding: "1rem 2.5rem" }}
                    >
                      <div className="row mb-2">
                        <div className="col-md-12">
                          <div className="row mt-2">
                            <label
                              className="col-sm-2 col-form-label"
                              htmlFor="collapsible-lastname"
                            >
                              Message Title
                            </label>
                            <div className="col-sm-3" id="assetFormLabel">
                              <input
                                title=""
                                required
                                type="text"
                                autoComplete="off"
                                id="multiStepsFirstName"
                                name="multiStepsFirstName"
                                className="form-control"
                                value={this.state.messageName}
                                onChange={this.handleMessageNameChange.bind(
                                  this
                                )}
                                validators={["required"]}
                                errormessages={["This field is required"]}
                              />
                            </div>
                          </div>
                          <div className="row mt-3">
                            <label
                              className="col-sm-2 col-form-label"
                              htmlFor="collapsible-firstname"
                            >
                              Message Type
                            </label>
                            <div className="col-sm-3" id="assetFormLabel">
                              <Autocomplete
                                id="size-small-outlined"
                                size="small"
                                fullWidth
                                disableClearable
                                autoComplete="off"
                                options={this.state.messageTypeList}
                                value={this.state.messageType}
                                ListboxProps={{
                                  className: "custom-listbox",
                                }}
                                getOptionLabel={(option) => option?.typeDetail}
                                defaultValue={this.state.messageType}
                                onChange={(event, value) => {
                                  this.handleMessageTypeChange(value);
                                }}
                                inputprops={{
                                  style: { textTransform: "capitalize" },
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder="Please Select"
                                    variant="outlined"
                                    size="small"
                                    className="autoComplete"
                                    // required
                                    style={{ background: "#fff" }}
                                  />
                                )}
                              />
                            </div>
                          </div>
                          <div className="row mt-3">
                            <label
                              className="col-sm-2 col-form-label"
                              htmlFor="collapsible-firstname"
                            >
                              Business Type
                            </label>
                            <div className="col-sm-3" id="assetFormLabel">
                              <Autocomplete
                                id="size-small-outlined"
                                size="small"
                                fullWidth
                                disableClearable
                                autoComplete="off"
                                options={this.state.businessTypeList}
                                value={this.state.businessType}
                                getOptionLabel={(option) => option.name}
                                defaultValue={this.state.businessType}
                                onChange={(event, value) => {
                                  this.handleBusinessTypeChange(value);
                                }}
                                inputprops={{
                                  style: { textTransform: "capitalize" },
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder="Please Select"
                                    variant="outlined"
                                    size="small"
                                    className="autoComplete"
                                    style={{ background: "#fff" }}
                                  />
                                )}
                              />
                            </div>
                          </div>
                          <div className="row mt-2">
                            {Utils.equalsIgnoreCase(
                              this.state.messageType?.type,
                              MESSAGE_TYPES.optIn
                            ) ||
                              Utils.equalsIgnoreCase(
                                this.state.messageType?.type,
                                MESSAGE_TYPES.textToPledge
                              ) ? (
                              <>
                                <label
                                  className="col-sm-2 col-form-label"
                                  htmlFor="collapsible-firstname"
                                >
                                  Keyword
                                </label>
                                <div className="col-sm-3" id="assetFormLabel">
                                  <input
                                    title=""
                                    required
                                    type="text"
                                    autoComplete="off"
                                    id="multiStepsFirstName"
                                    name="multiStepsFirstName"
                                    className="form-control"
                                    value={this.state.keyword}
                                    onChange={this.handleKeywordChange.bind(
                                      this
                                    )}
                                    validators={["required"]}
                                    errormessages={["This field is required"]}
                                  />
                                  {this.state.keywordSpaceError && (
                                    <div style={{ color: "red" }}>
                                      Keyword cannot have space
                                    </div>
                                  )}
                                </div>
                                <div className="col-sm-4">
                                  {this.state.keywordErrormessage ? (
                                    <span
                                      style={{ fontSize: "12px", color: "red" }}
                                    >
                                      Off-limit Keywords: HELP, CANCEL, GIVBEE,
                                      STOP, UNSUBSCRIBE, QUIT, REMOVE, OFF,
                                      OPTIN, OPTOUT, OUTPUT, DELETE, STOPALL,
                                      ARRET, START, END.
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </>
                            ) : (
                              <>
                                <label
                                  className="col-sm-2 col-form-label"
                                  htmlFor="collapsible-firstname"
                                >
                                  Keyword
                                </label>
                                <div className="col-sm-3" id="assetFormLabel">
                                  <input
                                    type="text"
                                    autoComplete="off"
                                    id="multiStepsFirstName"
                                    name="multiStepsFirstName"
                                    className="form-control"
                                    value={this.state.keyword}
                                    onChange={this.handleKeywordChange.bind(
                                      this
                                    )}
                                    validators={["required"]}
                                    errormessages={["This field is required"]}
                                  />
                                  {this.state.keywordSpaceError && (
                                    <div style={{ color: "red" }}>
                                      Keyword cannot have space
                                    </div>
                                  )}
                                </div>
                                <div className="col-sm-4">
                                  {this.state.keywordErrormessage ? (
                                    <span
                                      style={{ fontSize: "12px", color: "red" }}
                                    >
                                      Off-limit Keywords: HELP, CANCEL, GIVBEE,
                                      STOP, UNSUBSCRIBE, QUIT, REMOVE, OFF,
                                      OPTIN, OPTOUT, OUTPUT, DELETE, STOPALL,
                                      ARRET, START, END.
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </>
                            )}
                          </div>
                          <div className="row mt-2">
                            <label
                              className="col-sm-2 col-form-label"
                              htmlFor="collapsible-firstname"
                            >
                              Color Code
                            </label>
                            <div
                              className="col-sm-3 messageSelectColorCode align-self-center"
                              id="assetFormLabel"
                            >
                              <Select
                                value={this.state.colorCodeId}
                                onChange={(event) =>
                                  this.handleColorCodeChange(event)
                                }
                                className="selectColorCode"
                                style={{
                                  backgroundColor: this.state.colorCode,
                                }}
                                renderValue={() => null}
                                MenuProps={{
                                  PaperProps: {
                                    style: {
                                      maxHeight: 250,
                                      overflowY: "auto",
                                    },
                                  },
                                  MenuListProps: {
                                    className: "colorMenuListWrap",
                                  },
                                  anchorOrigin: {
                                    vertical: "bottom",
                                    horizontal: "left",
                                  },
                                  transformOrigin: {
                                    vertical: "top",
                                    horizontal: "left",
                                  },
                                }}
                              >
                                {this.state.smsCategoryColorList?.map(
                                  (option) => (
                                    <MenuItem
                                      key={option.id}
                                      value={option.id} // ✅ use ID here
                                      className="colorCodeMenuItem"
                                      sx={{
                                        display: "flex",
                                        fontSize: "15px", // fixed typo
                                      }}
                                    >
                                      <span
                                        style={{
                                          backgroundColor: option.hashColor,
                                          width: 18,
                                          height: 18,
                                          borderRadius: 3,
                                          marginTop: "6px",
                                          display: "inline-block",
                                          border: "1px solid #ccc",
                                        }}
                                      />
                                    </MenuItem>
                                  )
                                )}
                              </Select>
                            </div>
                          </div>
                        </div>
                      </div>
                      {Utils.equalsIgnoreCase(
                        this.state.messageType?.type,
                        MESSAGE_TYPES.interactive
                      ) && (
                          <>
                            <hr className="mb-0"></hr>
                            <div className="row mb-2 mt-3">
                              {questionitems.length === 0 && (
                                <div className="row">
                                  <div
                                    className="col-md-8"
                                    style={{
                                      background: "#ececec",
                                      color: "#000",
                                      fontWeight: "bold",
                                      border: "0.5px solid #ece6e6",
                                      padding: "0.5em",
                                    }}
                                  >
                                    {/* Message Type */}
                                  </div>
                                  <div
                                    className="col-md-4"
                                    style={{
                                      borderRight: "1px solid #eceaea",
                                      background: "#ececec",
                                      color: "#000",
                                      fontWeight: "bold",
                                      padding: "0.5em",
                                      textAlign: "right",
                                    }}
                                  >
                                    <Button
                                      type="button"
                                      variant="contained"
                                      className="btn btn-default "
                                      style={{
                                        textTransform: "capitalize",
                                        padding: "5px 10px",
                                        background: "#37517e",
                                        color: "#fff",
                                        fontWeight: "bold",
                                      }}
                                      startIcon={<AddIcon />}
                                      onClick={this.addQuestionItem.bind(this)}
                                    >
                                      Insert Message
                                    </Button>
                                  </div>
                                </div>
                              )}
                              <div className="row">
                                <label className="col-sm-1 col-form-label">
                                  Messages
                                </label>
                                <div className="col-sm-11">{questionitems}</div>
                              </div>
                            </div>
                            <div className="row justify-content-end">
                              <div className="col-sm-10">
                                <label
                                  htmlFor="exampleFormControlTextarea1"
                                  className="col-form-label"
                                >
                                  Closing Msg
                                </label>
                                <div className="row d-flex mb-2">
                                  <div className="col-md-6">
                                    <textarea
                                      title=""
                                      required
                                      value={this.state.closingTextMessage}
                                      onChange={this.handleClosingTextMessageChange.bind(
                                        this
                                      )}
                                      onBlur={this.handleClosingTextMessageChange.bind(
                                        this
                                      )}
                                      className="form-control"
                                      id="closingMessageBox"
                                      rows="3"
                                    // style={{ width: "518px" }}
                                    />
                                    {this.accountSettings?.textMessageLength <
                                      Utils.countLetters(
                                        this.state.closingTextMessage
                                      ) && (
                                        <span
                                          className="danger ms-1"
                                          style={{ color: "red", fontSize: "14px" }}
                                        >
                                          Your message is limited to{" "}
                                          {this.accountSettings?.textMessageLength}{" "}
                                          characters.
                                        </span>
                                      )}
                                    <span
                                      style={{
                                        fontSize: "14px",
                                        float: "right",
                                      }}
                                    >
                                      {this.accountSettings?.textMessageLength -
                                        Utils.trimLetters(
                                          this.state.closingTextMessage
                                        )}
                                      /{this.accountSettings?.textMessageLength}
                                    </span>
                                  </div>
                                  <div className="col-md-3">
                                    <ul
                                      className="p-0"
                                      style={{ listStyle: "none" }}
                                    >
                                      {this.state.smsVariablesList.map(
                                        (data, index) => {
                                          return (
                                            <>
                                              <li
                                                className="d-flex mt-1 variableButton"
                                                onClick={this.handleClosingInsert.bind(
                                                  this,
                                                  data
                                                )}
                                              >
                                                {data.name === "FirstName" && (
                                                  <IconButton className="pe-1">
                                                    <ChatBubbleOutlineIcon
                                                      style={{
                                                        fontSize: "16px",
                                                        width: "25px",
                                                      }}
                                                    />
                                                  </IconButton>
                                                )}
                                                {data.name === "EventName" && (
                                                  <IconButton className="pe-1">
                                                    <i
                                                      class="fa fa-plus"
                                                      aria-hidden="true"
                                                      style={{
                                                        fontSize: "16px",
                                                        width: "25px",
                                                      }}
                                                    ></i>
                                                  </IconButton>
                                                )}
                                                {data.name === "PaymentLink" && (
                                                  <IconButton className="pe-1">
                                                    <i
                                                      class="fa fa-usd"
                                                      aria-hidden="true"
                                                      style={{
                                                        fontSize: "16px",
                                                        width: "25px",
                                                      }}
                                                    ></i>
                                                  </IconButton>
                                                )}
                                                <span
                                                  style={{
                                                    cursor: "pointer",
                                                  }}
                                                  key={index}
                                                  draggable
                                                >
                                                  {data.description}
                                                </span>
                                              </li>
                                            </>
                                          );
                                        }
                                      )}
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      {Utils.equalsIgnoreCase(
                        this.state.messageType?.type,
                        MESSAGE_TYPES.fundraising
                      ) && (
                          <>
                            <div className="row" style={{ marginTop: "1em" }}>
                              <div className="col-md-12">
                                <div className="card" id="giveBeeCard">
                                  <div className="card-body">
                                    <div className="row">
                                      <h6>
                                        <b>Choose a Donor Experience</b>
                                      </h6>
                                    </div>
                                    {this.state.smsFundraisingOptionList.map(
                                      (row, index) => {
                                        return (
                                          <>
                                            <div className="row p-1">
                                              <label
                                                className="col-sm-2 col-form-label fw-bold"
                                                htmlFor="basic-default-supplierType"
                                                id="assetFormLabel"
                                              >
                                                <span className="me-2 custom-radio">
                                                  <input
                                                    type="radio"
                                                    value={row.id}
                                                    onChange={(e) =>
                                                      this.handleChange(e, row)
                                                    }
                                                    checked={row.isChecked}
                                                  />
                                                </span>
                                                {row.name}{" "}
                                                <span className="ms-4 fw-normal">
                                                  {row.name ===
                                                    "With Introduction"
                                                    ? "(more descriptive)"
                                                    : "(fewer steps)"}
                                                </span>
                                              </label>
                                              <div className="col-sm-10 mt-2">
                                                <span>{row.description}</span>
                                              </div>
                                            </div>
                                          </>
                                        );
                                      }
                                    )}
                                    {this.state.isIntroMessage && (
                                      <div className="row p-1">
                                        <div className="col-sm-2 mt-2"></div>
                                        <div className="col-sm-8 mt-2">
                                          <span>
                                            Enter an Introduction Message that
                                            includes your organization's name and
                                            what this appeal is about. It must
                                            also elicit a "Yes" or "No" reply from
                                            recipient.
                                          </span>
                                          <textarea
                                            title=""
                                            required
                                            value={this.state.introMessage}
                                            onChange={this.handleIntroMessageChange.bind(
                                              this
                                            )}
                                            className="form-control"
                                            id="exampleFormControlTextarea1"
                                            rows="5"
                                          />
                                          <span
                                            className="ms-2"
                                            style={{
                                              fontSize: "12px",
                                              color: "black",
                                            }}
                                          >
                                            Whenever possible, please include
                                            opt-out language in your text message
                                            to show the carriers that you are
                                            following guidelines.
                                          </span>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="row" style={{ marginTop: "1em" }}>
                              <div className="col-md-12">
                                <div className="card" id="giveBeeCard">
                                  <div className="card-body">
                                    <div className="row mb-3">
                                      <div className="col-md-8">
                                        <label
                                          htmlFor="exampleFormControlTextarea1"
                                          className="form-label"
                                        >
                                          Your "How much?" Question*
                                        </label>
                                        <textarea
                                          title=""
                                          required
                                          value={this.state.amountQuestion}
                                          onChange={this.handleAmountQustionChange.bind(
                                            this
                                          )}
                                          className="form-control"
                                          id="exampleFormControlTextarea1"
                                          rows="5"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="row" style={{ marginTop: "1em" }}>
                              <div className="col-md-12">
                                <div className="card" id="giveBeeCard">
                                  <div className="card-body">
                                    <div className="row mb-3">
                                      <label
                                        htmlFor="exampleFormControlTextarea1"
                                        className="form-label"
                                      >
                                        Your Suggested Donation Amounts*
                                        <InfoTooltip
                                          data="Up to 4 allowed"
                                          style={{
                                            float: "right",
                                          }}
                                        />
                                      </label>
                                    </div>
                                    <div className="row mb-3 ">
                                      <div className="col-md-3 d-flex">
                                        <span className="input-group-addon">
                                          $
                                        </span>
                                        <input
                                          type="number"
                                          autoComplete="off"
                                          id="multiStepsFirstName"
                                          name="multiStepsFirstName"
                                          className="form-control rounded-0"
                                          value={this.state.donationAmount}
                                          onChange={this.handleDonationAmountChange.bind(
                                            this
                                          )}
                                        />
                                        <span>
                                          <button
                                            type="button"
                                            onClick={this.addDonationAmount.bind(
                                              this
                                            )}
                                            className="btn addDonationBtn btn-primary"
                                          >
                                            Add
                                          </button>
                                        </span>
                                      </div>
                                    </div>
                                    <div className="row mt-4">
                                      <div className="col-md-4">
                                        <ul
                                          style={{
                                            listStyle: "none",
                                            display: "flex",
                                          }}
                                        >
                                          {this.state.donationAmountList?.map(
                                            (amountValue, index) => {
                                              return (
                                                <>
                                                  {
                                                    <div className="donation d-flex">
                                                      <li>${amountValue}</li>
                                                      <span className="ms-4">
                                                        <i
                                                          className="fa fa-times"
                                                          aria-hidden="true"
                                                          onClick={this.deleteDonationAmount.bind(
                                                            this,
                                                            index
                                                          )}
                                                        ></i>
                                                      </span>
                                                    </div>
                                                  }
                                                </>
                                              );
                                            }
                                          )}
                                        </ul>
                                        <span className="asterisk">
                                          {this.state.donationAmountError
                                            ? "No suggested donation amounts are set."
                                            : ""}
                                        </span>
                                      </div>
                                    </div>
                                    <hr></hr>
                                    <div className="row">
                                      <div
                                        className="col-md-4 mt-1"
                                        id="assetFormLabel"
                                      >
                                        <label
                                          className="form-label "
                                          htmlFor="collapsible-supplierType"
                                        >
                                          Fundraising Goal*
                                        </label>
                                        <div className="row ms-1 d-flex flex-nowrap">
                                          <span className="input-group-addon">
                                            $
                                          </span>
                                          <input
                                            title=""
                                            required
                                            type="number"
                                            autoComplete="off"
                                            id="multiStepsFirstName"
                                            name="multiStepsFirstName"
                                            className="form-control rounded-0"
                                            value={this.state.fundraisingGoal}
                                            onChange={this.handleFundraisingGoalChange.bind(
                                              this
                                            )}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      {(Utils.equalsIgnoreCase(
                        this.state.messageType?.type,
                        MESSAGE_TYPES.standard
                      ) ||
                        Utils.equalsIgnoreCase(
                          this.state.messageType?.type,
                          MESSAGE_TYPES.optIn
                        ) ||
                        Utils.equalsIgnoreCase(
                          this.state.messageType?.type,
                          MESSAGE_TYPES.textToPledge
                        )) && (
                          <>
                            <hr></hr>
                            <div className="row">
                              <label
                                htmlFor="exampleFormControlTextarea1"
                                className="col-sm-2 form-label mb-0"
                              >
                                Message
                              </label>
                              <div className="col-sm-5" id="assetFormLabel">
                                <textarea
                                  title=""
                                  ref={this.textareaRef}
                                  required
                                  value={this.state.textMessage}
                                  onChange={this.handleTextMessageChange.bind(
                                    this
                                  )}
                                  onBlur={this.handleTextMessageChange.bind(this)}
                                  className="form-control"
                                  id="messageBox"
                                  rows="3"
                                  style={{ overflow: "hidden", resize: "vertical" }}
                                />
                              </div>
                              <div className="col-md-3">
                                <ul className="p-0" style={{ listStyle: "none" }}>
                                  {this.state.smsVariablesList.map(
                                    (data, index) => {
                                      return (
                                        <>
                                          <li
                                            className="d-flex mt-1 variableButton"
                                            onClick={this.handleTextMessageInsert.bind(
                                              this,
                                              data
                                            )}
                                          >
                                            {data.name === "FirstName" && (
                                              <IconButton className="pe-1">
                                                <ChatBubbleOutlineIcon
                                                  style={{
                                                    fontSize: "16px",
                                                    width: "25px",
                                                  }}
                                                />
                                              </IconButton>
                                            )}
                                            {data.name === "EventName" && (
                                              <IconButton className="pe-1">
                                                <i
                                                  class="fa fa-plus"
                                                  aria-hidden="true"
                                                  style={{
                                                    fontSize: "16px",
                                                    width: "25px",
                                                  }}
                                                ></i>
                                              </IconButton>
                                            )}
                                            {data.name === "PaymentLink" && (
                                              <IconButton className="pe-1">
                                                <i
                                                  class="fa fa-usd"
                                                  aria-hidden="true"
                                                  style={{
                                                    fontSize: "16px",
                                                    width: "25px",
                                                  }}
                                                ></i>
                                              </IconButton>
                                            )}
                                            <span
                                              style={{
                                                cursor: "pointer",
                                              }}
                                              key={index}
                                              draggable
                                            >
                                              {data.description}
                                            </span>
                                          </li>
                                        </>
                                      );
                                    }
                                  )}
                                  {/* <li
                                  className="mt-1 variableButton"
                                  onClick={this.handleAccountDropdownOpen.bind(
                                    this
                                  )}
                                >
                                  <IconButton
                                    className="pe-1"
                                    style={{ height: "15px" }}
                                  >
                                    <AddLinkIcon
                                      style={{
                                        fontSize: "20px",
                                        width: "25px",
                                      }}
                                    />
                                  </IconButton>
                                  <span>Insert Short Link</span>
                                </li> */}
                                </ul>
                              </div>
                            </div>
                          </>
                        )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row d-flex align-items-center justify-content-between">
                <div className="col-sm-12 mt-3 text-center">
                  <CreateButton btnName="Create" type="submit" />
                  &nbsp;&nbsp;
                  <CancelIconButton onClick={(e) => this.createCancel()} />
                </div>
              </div>
            </ValidatorForm>
          </div>
        </>
      );
    }
  }
  viewMessageTemplate() {
    let updatedMessages = [
      ...this.state.questionItems,
      {
        question: this.state.closingTextMessage,
        step: this.state.questionItems?.length + 1,
      },
    ];
    if (this.state.render === false) {
      return <div />;
    } else {
      // let questionitems = [];
      // let itemLoc = 1;
      // this.state.questionItems.forEach((element, index) => {
      //   element.step = itemLoc++;
      //   let itemkey = index + "-" + this.state.refreshKey;
      //   questionitems.push(
      //     <MessageTemplateQuestion
      //       key={itemkey}
      //       data={element}
      //       srno={index + 1}
      //       action="view"
      //       iteamIndex={index}
      //     />
      //   );
      // });
      return (
        <>
          <AdminMenuWithBreadScrum
            breadCrumb={this.breadCrumb}
            history={this.props.history}
            domainObject={this.state.messageName}
            name={this.title}
            businessDomain={this.state.businessDomain}
            pageId="MessageTemplate"
            backCallback={this.viewCancel.bind(this)}
            editCallback={this.editMsgTemplateDetails.bind(this)}
            deleteCallback={this.deleteMsgTemplateDetails.bind(this)}
            getDeletePermission={this.state.getDeletePermission}
            getUpdatePermission={this.state.getUpdatePermission}
          />
          <div className="row" style={{ padding: "1em", marginTop: "-12px" }}>
            <div className="card" id="organizationFormCard">
              <div className="row">
                <div className="card-body">
                  <div className="row">
                    <label
                      className="col-sm-2 col-form-label fw-bold ps-0"
                      htmlFor="basic-default-Image"
                      id="assetFormLabel"
                    >
                      Message
                    </label>
                    {!Utils.equalsIgnoreCase(
                      this.state.messageType?.type,
                      MESSAGE_TYPES.interactive
                    ) && (
                        <>
                          <div className="col-md-3" style={{ width: "385px" }}>
                            <div className="chat-bubble">
                              {Utils.equalsIgnoreCase(
                                this.state.messageType?.type,
                                MESSAGE_TYPES.fundraising
                              )
                                ? this.state.amountQuestion
                                : this.state.textMessage}
                            </div>
                          </div>
                        </>
                      )}
                    {Utils.equalsIgnoreCase(
                      this.state.messageType?.type,
                      MESSAGE_TYPES.interactive
                    ) && (
                        <>
                          <div className="col-sm-3 mt-2 ps-0">
                            <div className="chat-bubble">
                              <span>
                                {
                                  updatedMessages[this.state.currentIndex]
                                    ?.question
                                }
                              </span>

                              {this.state.currentIndex <
                                updatedMessages.length - 1 && (
                                  <IconButton
                                    onClick={this.handleNext}
                                    className="chat-nav-button chat-next"
                                    size="small"
                                  >
                                    <ArrowForward fontSize="small" />
                                  </IconButton>
                                )}

                              {this.state.currentIndex > 0 && (
                                <IconButton
                                  onClick={this.handlePrev}
                                  className="chat-nav-button chat-prev"
                                  size="small"
                                >
                                  <ArrowBack fontSize="small" />
                                </IconButton>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                    <div className="col-md-4">
                      <div className="row pt-1">
                        <label
                          className="col-sm-4 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Message Title
                        </label>
                        <div className="col-sm-8" id="givbeeText">
                          <span>{this.state.messageName}</span>
                        </div>
                      </div>
                      <div className="row pt-1">
                        <label
                          className="col-sm-4 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Message Type
                        </label>
                        <div className="col-sm-8" id="givbeeText">
                          <span>{this.state.messageType?.type}</span>
                        </div>
                      </div>
                      <div className="row pt-1">
                        <label
                          className="col-sm-4 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Business Type
                        </label>
                        <div className="col-sm-8" id="givbeeText">
                          <span>{this.state.businessType?.name}</span>
                        </div>
                      </div>
                      <div className="row pt-1">
                        <label
                          className="col-sm-4 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Keyword
                        </label>
                        <div className="col-sm-8" id="givbeeText">
                          <span>{this.state.keyword}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-4 text-center">
              <Button
                type="submit"
                variant="contained"
                size="small"
                style={{
                  background: "#717373",
                  color: "#fff",
                  marginRight: "1rem",
                }}
                startIcon={<ArrowBackIcon />}
                onClick={(e) => this.viewCancel()}
              >
                Back
              </Button>
            </div>
          </div>
        </>
      );
    }
  }
  editMessageTemplate() {
    let questionitems = [];
    let itemLoc = 1;
    this.state.questionItems.forEach((element, index) => {
      if ("Delete" !== element.operation) {
        element.step = itemLoc++;
        let itemkey = index + "-" + this.state.refreshKey;
        questionitems.push(
          <MessageTemplateQuestion
            ref={this.itemReferenceList[index]}
            key={itemkey}
            data={element}
            interactiveQuestionTypeList={this.state.interactiveQuestionTypeList}
            smsVariablesList={this.state.smsVariablesList}
            srno={index}
            action="edit"
            iteamIndex={index}
            questionItems={this.state.questionItems}
            onAdd={this.addQuestionItem.bind(this)}
            onDelete={this.QuestionItemDeleted.bind(this)}
            onSuccess={this.smsQuestionTypeChange.bind(this)}
          />
        );
      }
    });
    return (
      <>
        <AdminMenuWithBreadScrum
          breadCrumb={this.breadCrumb}
          history={this.props.history}
          name={this.title}
          businessDomain={this.state.businessDomain}
          pageId="viewPage"
        />
        <div className="row">
          <ValidatorForm
            className="text-start"
            ref="form"
            onSubmit={this.updateMsgTemplateToBackend.bind(this)}
          >
            <div className="row">
              <div className="col-md-12">
                <div className="card " id="giveBeeCard">
                  <div
                    className="card-body p-2"
                  // style={{ padding: "1rem 2.5rem" }}
                  >
                    <div className="row mb-2">
                      <div className="col-md-12">
                        <div className="row mt-2">
                          <label
                            className="col-sm-2 col-form-label"
                            htmlFor="collapsible-lastname"
                          >
                            Message Title
                          </label>
                          <div className="col-sm-3" id="assetFormLabel">
                            <input
                              title=""
                              required
                              type="text"
                              autoComplete="off"
                              id="multiStepsFirstName"
                              name="multiStepsFirstName"
                              className="form-control"
                              value={this.state.messageName}
                              onChange={this.handleMessageNameChange.bind(this)}
                              validators={["required"]}
                              errormessages={["This field is required"]}
                            />
                          </div>
                        </div>
                        <div className="row mt-3">
                          <label
                            className="col-sm-2 col-form-label"
                            htmlFor="collapsible-firstname"
                          >
                            Message Type
                          </label>
                          <div className="col-sm-3" id="assetFormLabel">
                            <Autocomplete
                              id="size-small-outlined"
                              size="small"
                              fullWidth
                              disableClearable
                              autoComplete="off"
                              options={this.state.messageTypeList}
                              value={this.state.messageType}
                              ListboxProps={{
                                className: "custom-listbox",
                              }}
                              getOptionLabel={(option) => option?.typeDetail}
                              defaultValue={this.state.messageType}
                              onChange={(event, value) => {
                                this.handleMessageTypeChange(value);
                              }}
                              inputprops={{
                                style: { textTransform: "capitalize" },
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  disabled
                                  placeholder="Please Select"
                                  variant="outlined"
                                  size="small"
                                  className="autoComplete"
                                  // required
                                  style={{ background: "#fff" }}
                                />
                              )}
                            />
                          </div>
                        </div>
                        <div className="row mt-3">
                          <label
                            className="col-sm-2 col-form-label"
                            htmlFor="collapsible-firstname"
                          >
                            Business Type
                          </label>
                          <div className="col-sm-3" id="assetFormLabel">
                            <Autocomplete
                              id="size-small-outlined"
                              size="small"
                              fullWidth
                              disableClearable
                              autoComplete="off"
                              options={this.state.businessTypeList}
                              value={this.state.businessType}
                              getOptionLabel={(option) => option.name}
                              defaultValue={this.state.businessType}
                              onChange={(event, value) => {
                                this.handleBusinessTypeChange(value);
                              }}
                              inputprops={{
                                style: { textTransform: "capitalize" },
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder="Please Select"
                                  variant="outlined"
                                  size="small"
                                  className="autoComplete"
                                  style={{ background: "#fff" }}
                                />
                              )}
                            />
                          </div>
                        </div>
                        <div className="row mt-2">
                          {Utils.equalsIgnoreCase(
                            this.state.messageType?.type,
                            MESSAGE_TYPES.optIn
                          ) ||
                            Utils.equalsIgnoreCase(
                              this.state.messageType?.type,
                              MESSAGE_TYPES.textToPledge
                            ) ? (
                            <>
                              <label
                                className="col-sm-2 col-form-label"
                                htmlFor="collapsible-firstname"
                              >
                                Keyword
                              </label>
                              <div className="col-sm-3" id="assetFormLabel">
                                <input
                                  title=""
                                  required
                                  type="text"
                                  autoComplete="off"
                                  id="multiStepsFirstName"
                                  name="multiStepsFirstName"
                                  className="form-control"
                                  value={this.state.keyword}
                                  onChange={this.handleKeywordChange.bind(this)}
                                  validators={["required"]}
                                  errormessages={["This field is required"]}
                                />
                                {this.state.keywordSpaceError && (
                                  <div style={{ color: "red" }}>
                                    Keyword cannot have space
                                  </div>
                                )}
                              </div>
                              <div className="col-sm-4">
                                {this.state.keywordErrormessage ? (
                                  <span
                                    style={{ fontSize: "12px", color: "red" }}
                                  >
                                    Off-limit Keywords: HELP, CANCEL, GIVBEE,
                                    STOP, UNSUBSCRIBE, QUIT, REMOVE, OFF, OPTIN,
                                    OPTOUT, OUTPUT, DELETE, STOPALL, ARRET,
                                    START, END.
                                  </span>
                                ) : (
                                  ""
                                )}
                              </div>
                            </>
                          ) : (
                            <>
                              <label
                                className="col-sm-2 col-form-label"
                                htmlFor="collapsible-firstname"
                              >
                                Keyword
                              </label>
                              <div className="col-sm-3" id="assetFormLabel">
                                <input
                                  type="text"
                                  autoComplete="off"
                                  id="multiStepsFirstName"
                                  name="multiStepsFirstName"
                                  className="form-control"
                                  value={this.state.keyword}
                                  onChange={this.handleKeywordChange.bind(this)}
                                  validators={["required"]}
                                  errormessages={["This field is required"]}
                                />
                                {this.state.keywordSpaceError && (
                                  <div style={{ color: "red" }}>
                                    Keyword cannot have space
                                  </div>
                                )}
                              </div>
                              <div className="col-sm-4">
                                {this.state.keywordErrormessage ? (
                                  <span
                                    style={{ fontSize: "12px", color: "red" }}
                                  >
                                    Off-limit Keywords: HELP, CANCEL, GIVBEE,
                                    STOP, UNSUBSCRIBE, QUIT, REMOVE, OFF, OPTIN,
                                    OPTOUT, OUTPUT, DELETE, STOPALL, ARRET,
                                    START, END.
                                  </span>
                                ) : (
                                  ""
                                )}
                              </div>
                            </>
                          )}
                        </div>
                        <div className="row mt-2">
                          <label
                            className="col-sm-2 col-form-label"
                            htmlFor="collapsible-firstname"
                          >
                            Color Code
                          </label>
                          <div
                            className="col-sm-3 messageSelectColorCode align-self-center"
                            id="assetFormLabel"
                          >
                            <Select
                              value={this.state.colorCodeId}
                              onChange={(event) =>
                                this.handleColorCodeChange(event)
                              }
                              className="selectColorCode"
                              style={{
                                backgroundColor: this.state.colorCode,
                              }}
                              renderValue={() => null}
                              MenuProps={{
                                PaperProps: {
                                  style: {
                                    maxHeight: 250,
                                    overflowY: "auto",
                                  },
                                },
                                MenuListProps: {
                                  className: "colorMenuListWrap",
                                },
                                anchorOrigin: {
                                  vertical: "bottom",
                                  horizontal: "left",
                                },
                                transformOrigin: {
                                  vertical: "top",
                                  horizontal: "left",
                                },
                              }}
                            >
                              {this.state.smsCategoryColorList?.map(
                                (option) => (
                                  <MenuItem
                                    key={option.id}
                                    value={option.id} // ✅ use ID here
                                    className="colorCodeMenuItem"
                                    sx={{
                                      display: "flex",
                                      fontSize: "15px", // fixed typo
                                    }}
                                  >
                                    <span
                                      style={{
                                        backgroundColor: option.hashColor,
                                        width: 18,
                                        height: 18,
                                        borderRadius: 3,
                                        marginTop: "6px",
                                        display: "inline-block",
                                        border: "1px solid #ccc",
                                      }}
                                    />
                                  </MenuItem>
                                )
                              )}
                            </Select>
                          </div>
                        </div>
                      </div>
                    </div>
                    {Utils.equalsIgnoreCase(
                      this.state.messageType?.type,
                      MESSAGE_TYPES.interactive
                    ) && (
                        <>
                          <hr className="mb-0"></hr>
                          <div className="row mb-2 mt-3">
                            {questionitems.length === 0 && (
                              <div className="row">
                                <div
                                  className="col-md-8"
                                  style={{
                                    background: "#ececec",
                                    color: "#000",
                                    fontWeight: "bold",
                                    border: "0.5px solid #ece6e6",
                                    padding: "0.5em",
                                  }}
                                >
                                  {/* Message Type */}
                                </div>
                                <div
                                  className="col-md-4"
                                  style={{
                                    borderRight: "1px solid #eceaea",
                                    background: "#ececec",
                                    color: "#000",
                                    fontWeight: "bold",
                                    padding: "0.5em",
                                    textAlign: "right",
                                  }}
                                >
                                  <Button
                                    type="button"
                                    variant="contained"
                                    className="btn btn-default "
                                    style={{
                                      textTransform: "capitalize",
                                      padding: "5px 10px",
                                      background: "#37517e",
                                      color: "#fff",
                                      fontWeight: "bold",
                                    }}
                                    startIcon={<AddIcon />}
                                    onClick={this.addQuestionItem.bind(this)}
                                  >
                                    Insert Message
                                  </Button>
                                </div>
                              </div>
                            )}
                            <div className="row">
                              <label className="col-sm-1 col-form-label">
                                Messages
                              </label>
                              <div className="col-sm-11">{questionitems}</div>
                            </div>
                          </div>
                          <div className="row justify-content-end">
                            <div className="col-sm-10">
                              <label
                                htmlFor="exampleFormControlTextarea1"
                                className="col-form-label"
                              >
                                Closing Msg
                              </label>
                              <div className="row d-flex mb-2">
                                <div className="col-md-6">
                                  <textarea
                                    title=""
                                    required
                                    value={this.state.closingTextMessage}
                                    onChange={this.handleClosingTextMessageChange.bind(
                                      this
                                    )}
                                    onBlur={this.handleClosingTextMessageChange.bind(
                                      this
                                    )}
                                    className="form-control"
                                    id="closingMessageBox"
                                    rows="3"
                                  // style={{ width: "518px" }}
                                  />
                                </div>
                                <div className="col-md-3">
                                  <ul
                                    className="p-0"
                                    style={{ listStyle: "none" }}
                                  >
                                    {this.state.smsVariablesList.map(
                                      (data, index) => {
                                        return (
                                          <>
                                            <li
                                              className="d-flex mt-1 variableButton"
                                              onClick={this.handleClosingInsert.bind(
                                                this,
                                                data
                                              )}
                                            >
                                              {data.name === "FirstName" && (
                                                <IconButton className="pe-1">
                                                  <ChatBubbleOutlineIcon
                                                    style={{
                                                      fontSize: "16px",
                                                      width: "25px",
                                                    }}
                                                  />
                                                </IconButton>
                                              )}
                                              {data.name === "EventName" && (
                                                <IconButton className="pe-1">
                                                  <i
                                                    class="fa fa-plus"
                                                    aria-hidden="true"
                                                    style={{
                                                      fontSize: "16px",
                                                      width: "25px",
                                                    }}
                                                  ></i>
                                                </IconButton>
                                              )}
                                              {data.name === "PaymentLink" && (
                                                <IconButton className="pe-1">
                                                  <i
                                                    class="fa fa-usd"
                                                    aria-hidden="true"
                                                    style={{
                                                      fontSize: "16px",
                                                      width: "25px",
                                                    }}
                                                  ></i>
                                                </IconButton>
                                              )}
                                              <span
                                                style={{
                                                  cursor: "pointer",
                                                }}
                                                key={index}
                                                draggable
                                              >
                                                {data.description}
                                              </span>
                                            </li>
                                          </>
                                        );
                                      }
                                    )}
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    {Utils.equalsIgnoreCase(
                      this.state.messageType?.type,
                      MESSAGE_TYPES.fundraising
                    ) && (
                        <>
                          <div className="row" style={{ marginTop: "1em" }}>
                            <div className="col-md-12">
                              <div className="card" id="giveBeeCard">
                                <div className="card-body">
                                  <div className="row">
                                    <h6>
                                      <b>Choose a Donor Experience</b>
                                    </h6>
                                  </div>
                                  {this.state.smsFundraisingOptionList.map(
                                    (row, index) => {
                                      return (
                                        <>
                                          <div className="row p-1">
                                            <label
                                              className="col-sm-2 col-form-label fw-bold"
                                              htmlFor="basic-default-supplierType"
                                              id="assetFormLabel"
                                            >
                                              <span className="me-2 custom-radio">
                                                <input
                                                  type="radio"
                                                  value={row.id}
                                                  onChange={(e) =>
                                                    this.handleChange(e, row)
                                                  }
                                                  checked={row.isChecked}
                                                />
                                              </span>
                                              {row.name}{" "}
                                              <span className="ms-4 fw-normal">
                                                {row.name === "With Introduction"
                                                  ? "(more descriptive)"
                                                  : "(fewer steps)"}
                                              </span>
                                            </label>
                                            <div className="col-sm-10 mt-2">
                                              <span>{row.description}</span>
                                            </div>
                                          </div>
                                        </>
                                      );
                                    }
                                  )}
                                  {this.state.isIntroMessage && (
                                    <div className="row p-1">
                                      <div className="col-sm-2 mt-2"></div>
                                      <div className="col-sm-8 mt-2">
                                        <span>
                                          Enter an Introduction Message that
                                          includes your organization's name and
                                          what this appeal is about. It must also
                                          elicit a "Yes" or "No" reply from
                                          recipient.
                                        </span>
                                        <textarea
                                          title=""
                                          required
                                          value={this.state.introMessage}
                                          onChange={this.handleIntroMessageChange.bind(
                                            this
                                          )}
                                          className="form-control"
                                          id="exampleFormControlTextarea1"
                                          rows="5"
                                        />
                                        <span
                                          className="ms-2"
                                          style={{
                                            fontSize: "12px",
                                            color: "black",
                                          }}
                                        >
                                          Whenever possible, please include
                                          opt-out language in your text message to
                                          show the carriers that you are following
                                          guidelines.
                                        </span>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row" style={{ marginTop: "1em" }}>
                            <div className="col-md-12">
                              <div className="card" id="giveBeeCard">
                                <div className="card-body">
                                  <div className="row mb-3">
                                    <div className="col-md-8">
                                      <label
                                        htmlFor="exampleFormControlTextarea1"
                                        className="form-label"
                                      >
                                        Your "How much?" Question*
                                      </label>
                                      <textarea
                                        title=""
                                        required
                                        value={this.state.amountQuestion}
                                        onChange={this.handleAmountQustionChange.bind(
                                          this
                                        )}
                                        className="form-control"
                                        id="exampleFormControlTextarea1"
                                        rows="5"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row" style={{ marginTop: "1em" }}>
                            <div className="col-md-12">
                              <div className="card" id="giveBeeCard">
                                <div className="card-body">
                                  <div className="row mb-3">
                                    <label
                                      htmlFor="exampleFormControlTextarea1"
                                      className="form-label"
                                    >
                                      Your Suggested Donation Amounts*
                                      <InfoTooltip
                                        data="Up to 4 allowed"
                                        style={{
                                          float: "right",
                                        }}
                                      />
                                    </label>
                                  </div>
                                  <div className="row mb-3 ">
                                    <div className="col-md-3 d-flex">
                                      <span className="input-group-addon">$</span>
                                      <input
                                        type="number"
                                        autoComplete="off"
                                        id="multiStepsFirstName"
                                        name="multiStepsFirstName"
                                        className="form-control rounded-0"
                                        value={this.state.donationAmount}
                                        onChange={this.handleDonationAmountChange.bind(
                                          this
                                        )}
                                      />
                                      <span>
                                        <button
                                          type="button"
                                          onClick={this.addDonationAmount.bind(
                                            this
                                          )}
                                          className="btn addDonationBtn btn-primary"
                                        >
                                          Add
                                        </button>
                                      </span>
                                    </div>
                                  </div>
                                  <div className="row mt-4">
                                    <div className="col-md-4">
                                      <ul
                                        style={{
                                          listStyle: "none",
                                          display: "flex",
                                        }}
                                      >
                                        {this.state.donationAmountList?.map(
                                          (amountValue, index) => {
                                            return (
                                              <>
                                                {
                                                  <div className="donation d-flex">
                                                    <li>${amountValue}</li>
                                                    <span className="ms-4">
                                                      <i
                                                        className="fa fa-times"
                                                        aria-hidden="true"
                                                        onClick={this.deleteDonationAmount.bind(
                                                          this,
                                                          index
                                                        )}
                                                      ></i>
                                                    </span>
                                                  </div>
                                                }
                                              </>
                                            );
                                          }
                                        )}
                                      </ul>
                                      <span className="asterisk">
                                        {this.state.donationAmountError
                                          ? "No suggested donation amounts are set."
                                          : ""}
                                      </span>
                                    </div>
                                  </div>
                                  <hr></hr>
                                  <div className="row">
                                    <div
                                      className="col-md-4 mt-1"
                                      id="assetFormLabel"
                                    >
                                      <label
                                        className="form-label "
                                        htmlFor="collapsible-supplierType"
                                      >
                                        Fundraising Goal*
                                      </label>
                                      <div className="row ms-1 d-flex flex-nowrap">
                                        <span className="input-group-addon">
                                          $
                                        </span>
                                        <input
                                          title=""
                                          required
                                          type="number"
                                          autoComplete="off"
                                          id="multiStepsFirstName"
                                          name="multiStepsFirstName"
                                          className="form-control rounded-0"
                                          value={this.state.fundraisingGoal}
                                          onChange={this.handleFundraisingGoalChange.bind(
                                            this
                                          )}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    {(Utils.equalsIgnoreCase(
                      this.state.messageType?.type,
                      MESSAGE_TYPES.standard
                    ) ||
                      Utils.equalsIgnoreCase(
                        this.state.messageType?.type,
                        MESSAGE_TYPES.optIn
                      ) ||
                      Utils.equalsIgnoreCase(
                        this.state.messageType?.type,
                        MESSAGE_TYPES.textToPledge
                      )) && (
                        <>
                          <hr></hr>
                          <div className="row">
                            <label
                              htmlFor="exampleFormControlTextarea1"
                              className="col-sm-2 form-label mb-0"
                            >
                              Message
                            </label>
                            <div className="col-sm-5" id="assetFormLabel">
                              <textarea
                                title=""
                                ref={this.textareaRef}
                                required
                                value={this.state.textMessage}
                                onChange={this.handleTextMessageChange.bind(this)}
                                onBlur={this.handleTextMessageChange.bind(this)}
                                className="form-control"
                                id="messageBox"
                                rows="3"
                                style={{ overflow: "hidden", resize: "vertical" }}
                              />
                            </div>
                            <div className="col-md-3">
                              <ul className="p-0" style={{ listStyle: "none" }}>
                                {this.state.smsVariablesList.map(
                                  (data, index) => {
                                    return (
                                      <>
                                        <li
                                          className="d-flex mt-1 variableButton"
                                          onClick={this.handleTextMessageInsert.bind(
                                            this,
                                            data
                                          )}
                                        >
                                          {data.name === "FirstName" && (
                                            <IconButton className="pe-1">
                                              <ChatBubbleOutlineIcon
                                                style={{
                                                  fontSize: "16px",
                                                  width: "25px",
                                                }}
                                              />
                                            </IconButton>
                                          )}
                                          {data.name === "EventName" && (
                                            <IconButton className="pe-1">
                                              <i
                                                class="fa fa-plus"
                                                aria-hidden="true"
                                                style={{
                                                  fontSize: "16px",
                                                  width: "25px",
                                                }}
                                              ></i>
                                            </IconButton>
                                          )}
                                          {data.name === "PaymentLink" && (
                                            <IconButton className="pe-1">
                                              <i
                                                class="fa fa-usd"
                                                aria-hidden="true"
                                                style={{
                                                  fontSize: "16px",
                                                  width: "25px",
                                                }}
                                              ></i>
                                            </IconButton>
                                          )}
                                          <span
                                            style={{
                                              cursor: "pointer",
                                            }}
                                            key={index}
                                            draggable
                                          >
                                            {data.description}
                                          </span>
                                        </li>
                                      </>
                                    );
                                  }
                                )}
                                {/* <li
                                  className="mt-1 variableButton"
                                  onClick={this.handleAccountDropdownOpen.bind(
                                    this
                                  )}
                                >
                                  <IconButton
                                    className="pe-1"
                                    style={{ height: "15px" }}
                                  >
                                    <AddLinkIcon
                                      style={{
                                        fontSize: "20px",
                                        width: "25px",
                                      }}
                                    />
                                  </IconButton>
                                  <span>Insert Short Link</span>
                                </li> */}
                              </ul>
                            </div>
                          </div>
                        </>
                      )}
                  </div>
                </div>
              </div>
            </div>
            <div className="row d-flex align-items-center justify-content-between">
              <div className="col-sm-12 mt-3 text-center">
                <SaveButton id="saveButton" type="submit">
                  {" "}
                  Save{" "}
                </SaveButton>
                &nbsp;&nbsp;
                <CancelIconButton onClick={(e) => this.editCancel()} />
              </div>
            </div>
          </ValidatorForm>
        </div>
      </>
    );
  }
}
export default withRouter(MessageTemplate);
